import * as yup from 'yup';
import { BusFormValues } from '../types/busTypes';

const busSchema = yup.object({
  name: yup.string().trim().required('Bus name is required'),
  licensePlateNo: yup
    .string()
    .trim()
    .required('License plate number is required')
});

const validateBusForm = async (values: BusFormValues) => {
  return busSchema.validate(values, { abortEarly: false });
};

const parseValidationErrors = (
  error: any
): Partial<Record<keyof BusFormValues, string>> => {
  if (!error || !error.inner) return {};
  const fieldErrors: Partial<Record<keyof BusFormValues, string>> = {};
  error.inner.forEach((e: any) => {
    if (e.path) fieldErrors[e.path as keyof BusFormValues] = e.message;
  });
  return fieldErrors;
};

export { validateBusForm, parseValidationErrors, busSchema };
